import WithData from './data'

export default WithData
